import { render } from "./CustomLabelSwitch.vue?vue&type=template&id=60ed8cae&ts=true"
import script from "./CustomLabelSwitch.vue?vue&type=script&lang=ts"
export * from "./CustomLabelSwitch.vue?vue&type=script&lang=ts"

import "./CustomLabelSwitch.vue?vue&type=style&index=0&id=60ed8cae&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__